import { Pagination } from 'core/pagination/Pagination';

export type Retail = {
  id: string;
  name: string;
};

export type ProductWithPagination = {
  pagination: Pagination;
  products: Product[];
};

export type Product = {
  productId: string;
  retailId: string;
  name: string;
  category: string;
  salePrice: number;
  imgLink: string;
  multipack: number;
  vendorNumber?: string;
  adServingUrl?: string;
  customLabel3?: string;
  customLabel4?: string;
  tags: ProductTag[];
  brandId?: string;
  spending: number;
  availability?: ProductAvailability;
};

export type SmartGoodsHotKeywrods = {
  suggestKeywords: SuggestKeyword[];
  bidCap: number;
  bidFloor: number;
  bidPrice: number;
  bidMedian: number;
};

export type SuggestKeyword = {
  suggestKeyword: string;
  pr: number;
  cpc?: number;
};

export type GoodsHotKeywords = {
  suggestKeywords: SuggestKeyword[];
  bidCap: number;
  bidFloor: number;
  bidPrice: number;
  bidMedian: number;
};

export enum ProductTag {
  HOT = '熱門商品',
  TRENDING = '全站熱搜',
  ROAS = 'ROAS最佳',
  HCP = '高點擊商品',
}

export enum ProductAvailability {
  IN_STOCK = 'in_stock',
  OUT_OF_STOCK = 'out_of_stock',
  RECELL = 'recell', //下架，前端自定義狀態
}
